<script lang="ts">
  import { getFromObject } from '$shared/helpers/utils';
  import SensitiveText from '$shared/atoms/SensitiveText/SensitiveText.svelte';

  interface Props {
    row: ObjectType<any>;
    col: ColumnType;
    column: ColumnType;
  }

  let { row, col, column }: Props = $props();

  let value = $derived(getFromObject(col?.id || column?.id, row) || '');
</script>

<div class="comp-sensitivity-cell">
  <SensitiveText sensitiveData={value} hasObfuscatedLean />
</div>
